import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header.jsx';
import Footer from './Footer.jsx';
import FloatingActionButtons from '../common/FloatingActionButtons.jsx';

const MainLayout = () => {
  return (
    <div>
      <Header />
      <main>
        <Outlet />
      </main>
      <FloatingActionButtons />
      <Footer />
    </div>
  );
};

export default MainLayout;
